import httpStore from "@/api/httpStore";

export function getProvincias(country) {
  return httpStore
    .get(`/infoauto_address/provincias?nombre_pais=${country}`)
    .then(res => {
      return res.data;
    });
}

export function getCantones(codProvincia, codPais, nombrePais) {
  const params = new URLSearchParams();
  params.append("cod_provincia", codProvincia);
  if (codPais) {
    params.append("cod_pais", codPais);
  } else if (nombrePais) {
    params.append("nombre_pais", nombrePais);
  }
  return httpStore
    .get(`/infoauto_address/cantones?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}

export function getDistritos(provinciaCode, cantonCode, codPais, nombrePais) {
  const params = new URLSearchParams();
  params.append("cod_provincia", provinciaCode);
  params.append("cod_canton", cantonCode);
  if (codPais) {
    params.append("cod_pais", codPais);
  } else if (nombrePais) {
    params.append("nombre_pais", nombrePais);
  }
  return httpStore
    .get(`/infoauto_address/distritos?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}

export function getBarrios(
  provinciaCode,
  cantonCode,
  distritoCode,
  codPais,
  nombrePais
) {
  const params = new URLSearchParams();
  params.append("cod_provincia", provinciaCode);
  params.append("cod_canton", cantonCode);
  params.append("cod_distrito", distritoCode);
  if (codPais) {
    params.append("cod_pais", codPais);
  } else if (nombrePais) {
    params.append("nombre_pais", nombrePais);
  }
  return httpStore
    .get(`/infoauto_address/barrios?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}
